
import { useDispatch, useSelector } from 'react-redux';

import { XCircleIcon, ExclamationTriangleIcon} from '@heroicons/react/24/solid';
import { selectLangObj } from '../../reducers/langReducer';

function DetailsDialog({ show, notes, setShowDialog, children, titleElement, error }) {


  const langObj = useSelector(selectLangObj);

  var categories = {};
  if (notes) {
    for (let note of notes) {
      let key = note.категорија || "";

      if (categories[note.категорија]) {
        categories[key].push(note);
      } else {
        categories[key] = [note];
      }
    }

  }


  const handleClick = (e) => {
    // Only run if the click was on the parent itself
    if (e.target === e.currentTarget) {
      setShowDialog(false);
    }
  }


  return (
    <div onClick={handleClick} className={(show ? 'opacity-100 z-50' : ' -z-50 opacity-0 pointer-events-none ') + ' transition-opacity duration-500 text-gray-700 md:p-5 w-screen h-screen backdrop-blur-xl smd:p-6 overflow-auto flex flex-col justify-center items-center absolute top-0 left-0'}>
      {

        error ? (<div className='md:text-xl flex gap-1 items-center text-red-800'><ExclamationTriangleIcon className='size-5 md:size-10'></ExclamationTriangleIcon>{langObj["NoData"]}</div>) :
          (
            <div className='transition-all duration-300 rounded-xl overflow-hidden'>
              <div className=' text-3xl flex font-bold text-center bg-beige-700  align-middle items-center py-2 px-5 gap-3'>
                {titleElement ? titleElement : ""}
                <div className='grow'> </div>
                <button onClick={() => setShowDialog(false)} className='bg-none text-gray-700 size-12'><XCircleIcon></XCircleIcon></button>
              </div>
              <div className={' pt-3 overflow-auto flex flex-col items-stretch justify-center bg-beige-700 font-semibold'}>

                {children}


                <div className='bg-beige-500 p-5 flex flex-col items-start gap-3 font-normal'>

                  {(Object.keys(categories).map((key, index) => {
                    if (key && categories[key]) {
                      return (<div className='flex flex-col items-start gap-1 md:mb-3 mb-1'><div className='text-xl'><strong>{key}:</strong></div>
                        <div className='flex flex-col items-start gap-1'>
                          {
                            categories[key].map(
                              (item, index) =>
                                item.линк ? (
                                  <div key={index}>
                                    <a className='text-blue-600 underline text-left' href={item.линк} target='_blank' rel='noreferrer'>
                                      {item.текст}
                                    </a>
                                  </div>
                                ) : (


                                  <div key={index}>
                                    {item.текст}
                                  </div>
                                )
                            )
                          }

                        </div>
                      </div>)
                    }
                    else {
                      return <div key={index}>...</div>;
                    }
                  }

                  ))}
                </div>
              </div>

            </div>)

      }

    </div>
  );
}

export default DetailsDialog;
